import React, { useState } from 'react'
import { Icon } from "@iconify/react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import "../../Components/common/AddEmployeeModel.css";

const EditOfficalMail = ({ onClose, employeeId, onSuccess }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    officeEmail: "",
    password: "",
    confirmPassword: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.officeEmail || !formData.password || !formData.confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/${employeeId}/credentials`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Official mail generated successfully");

      onSuccess?.(); // refresh parent list
      onClose();     // close modal
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to generate official mail"
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="modal-overlay">
      <ToastContainer position="top-right" autoClose={3000} />
      <div style={{
        backgroundColor: "white",
        padding: "2vh",
        borderRadius: "8px",
        width: "85%",
        height: "90%",
        maxWidth: "623px",
        maxHeight: "100%",
        overflowY: "auto",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        display: "flex",
        flexDirection: "column",
        scrollbarWidth: "none", // Note: This only affects Firefox
      }}>
        <div className="modal-container">
          {/* Header */}
          <div className="modal-header">
            <p className='mt-3'>Generate Official Mail</p>
            <button onClick={onClose} className="close-btn">
              <Icon icon="iconoir:cancel" width="24" height="24" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className=" mt-5 modal-forms">
            {/* Company Email */}
            <div className="form-groups">
              <label>
                Company Email<span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="officeEmail"
                value={formData.officeEmail}
                onChange={handleChange}
                placeholder="abc@raksoftech.com"
                required
                pattern="^(?!.*\.\.)(?!\.)[a-zA-Z0-9._]{2,}(?<!\.)@raksoftech\.com$"
                title="Enter valid raksoftech.com email"
              />
            </div>

            {/* Password */}

            <div className="form-groups password-wrapper">
              <label>
                Password<span style={{ color: "red" }}>*</span>
              </label>

              <div className="input-with-icon">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  required
                />

                <Icon
                  icon={showPassword ? "mdi:eye-off" : "mdi:eye"}
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>

            {/* Confirm Password */}
            <div className="form-groups password-wrapper">
              <label>
                Confirm Password<span style={{ color: "red" }}>*</span>
              </label>

              <div className="input-with-icon">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm Password"
                  required
                />

                <Icon
                  icon={showConfirmPassword ? "mdi:eye-off" : "mdi:eye"}
                  className="eye-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              </div>
            </div>


            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="mt-4 submit-btn"
              style={{
                opacity: loading ? 0.6 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Generating..." : "Generate Mail"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditOfficalMail